module.exports = __webpack_public_path__ + "img/mesa_el_d.63c67a33.png";